import { useCallback, useEffect, useState } from "react";

import {
  ABLAGE_EREIGNIS,
  ablageEntfernen,
  ablageErgaenzen,
  ablageLeeren,
  ablageLesen,
  type AblageEintrag,
} from "../lib/invoiceClipboard";

/**
 * Die Zwischenablage als React-Zustand.
 *
 * Sie liegt im Browser, nicht auf dem Server (Begründung in
 * `lib/invoiceClipboard.ts`), deshalb kein React Query. Zwei Ereignisse
 * halten die Ansicht aktuell: `storage` meldet Änderungen aus **anderen**
 * Tabs, das eigene `ABLAGE_EREIGNIS` die aus diesem — `storage` feuert im
 * auslösenden Tab nämlich nicht.
 */
export function useInvoiceClipboard() {
  const [eintraege, setEintraege] = useState<AblageEintrag[]>(ablageLesen);

  useEffect(() => {
    const auffrischen = () => setEintraege(ablageLesen());
    window.addEventListener(ABLAGE_EREIGNIS, auffrischen);
    window.addEventListener("storage", auffrischen);
    return () => {
      window.removeEventListener(ABLAGE_EREIGNIS, auffrischen);
      window.removeEventListener("storage", auffrischen);
    };
  }, []);

  const ergaenzen = useCallback((neu: AblageEintrag[]) => setEintraege(ablageErgaenzen(neu)), []);
  const entfernen = useCallback((id: string) => setEintraege(ablageEntfernen(id)), []);
  const leeren = useCallback(() => setEintraege(ablageLeeren()), []);

  return { eintraege, ergaenzen, entfernen, leeren };
}
